module.exports = __webpack_public_path__ + "static/media/main.01b260de.png";